import { ICreateMarathon } from "features/createEditMarathon/model/types";
import { Control, useFieldArray } from "react-hook-form";

interface UsePartnerCompanyProps {
  control: Control<ICreateMarathon, any>;
  index: number;
}

export const usePartnerCompany = ({
  control,
  index,
}: UsePartnerCompanyProps) => {
  const { append, fields, remove } = useFieldArray({
    name: `partners.${index}.partnerCompanies`,
    control,
  });

  return {
    append,
    fields,
    remove,
  };
};
